export default __webpack_public_path__ + "static/media/logo_media.e62e5b48.svg";